/**
 * <AuthControls> — the language + theme control cluster for the auth shell.
 *
 * Pinned to the form column's logical-end edge by <AuthLayout>. Reuses the
 * design-system <ThemeToggleButton> (sun/moon, DOM + localStorage) WITHOUT
 * `onPrefsChange` — there is no session pre-auth, so a theme flip must never
 * try to PATCH /me/preferences. <LanguageSwitcher> sits beside it.
 */
import type { JSX } from "react";
import { ThemeToggleButton } from "@linkhr/design-system";
import { LanguageSwitcher } from "./LanguageSwitcher.js";

export function AuthControls(): JSX.Element {
  return (
    <div className="flex items-center gap-xs">
      <LanguageSwitcher />
      <ThemeToggleButton />
    </div>
  );
}
